/* eslint-disable no-throw-literal */
import {
  GET_SAFETY_CONFIRMATION_ANSWER, UPDATE_SAFETY_CONFIRMATION_ANSWER
} from './mutation-types'

export default {
  actions: {
    async [GET_SAFETY_CONFIRMATION_ANSWER] ({ dispatch }) {
      console.log('GET_SAFETY_CONFIRMATION_ANSWER')
      const res = await dispatch('apiGet', { url: '/asovi/safety_confirmations' })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [UPDATE_SAFETY_CONFIRMATION_ANSWER] ({ dispatch }, params) {
      const res = await dispatch('apiPost', { url: `/asovi/safety_confirmations`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  },
  mutations: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/safety-confirmation.js